import { Button } from '@/components/ui/button'
import { ArrowRight } from 'lucide-react'
import type { User } from '@/types'

interface LandingHeroProps {
  user?: User | null
}

export function LandingHero({ user }: LandingHeroProps) {
  return (
    <section className="w-full pt-12 pb-16 sm:pt-16 sm:pb-24 lg:pt-20 lg:pb-28 bg-white overflow-hidden">
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          
          {/* Left Column: Heading & CTAs */}
          <div className="lg:col-span-6 space-y-6 sm:space-y-8 text-center lg:text-left">
            <div className="space-y-4">
              <h1 className="!font-sans text-4xl sm:text-5xl lg:text-[62px] font-black text-[#131b2e] tracking-tight leading-[1.08]">
                Master Competitive<br />
                Exams with<br />
                Confidence
              </h1>
              <p className="!font-sans text-base sm:text-lg text-slate-600 max-w-xl mx-auto lg:mx-0 font-normal leading-relaxed">
                Practice with high-yield mock tests, analyze performance, and succeed. India&apos;s trusted platform for exam readiness.
              </p>
            </div>

            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 pt-2">
              {user ? (
                <Button asChild size="lg" className="!font-sans w-full sm:w-auto bg-[#131b2e] hover:bg-[#1e293b] text-white font-bold px-8 h-12 rounded-lg shadow-md text-base flex items-center justify-center transition-all">
                  <a href={user.role === 'admin' ? '/admin' : '/student'}>
                    Start Free Test
                    <ArrowRight className="w-4 h-4 ml-2" />
                  </a>
                </Button>
              ) : (
                <Button asChild size="lg" className="!font-sans w-full sm:w-auto bg-[#131b2e] hover:bg-[#1e293b] text-white font-bold px-8 h-12 rounded-lg shadow-md text-base flex items-center justify-center transition-all">
                  <a href="/users/sign_up">
                    Start Free Test
                    <ArrowRight className="w-4 h-4 ml-2" />
                  </a>
                </Button>
              )}
              <Button asChild size="lg" variant="outline" className="!font-sans w-full sm:w-auto bg-transparent hover:bg-slate-100 border-2 border-[#131b2e] text-[#131b2e] font-bold px-7 h-12 rounded-lg text-base transition-all">
                <a href="#exams">
                  View All Exams
                </a>
              </Button>
            </div>
          </div>

          {/* Right Column: Hero Illustration Asset */}
          <div className="lg:col-span-6 flex justify-center lg:justify-end">
            <img
              src="/landing-hero-illustration.png"
              alt="Student Preparing for Competitive Exams with Confidence"
              className="w-full max-w-[580px] h-auto object-contain select-none drop-shadow-sm"
              loading="eager"
            />
          </div>

        </div>
      </div>
    </section>
  )
}
